/**
 * 使用 Web Crypto API 计算字符串的 SHA-256 hash
 * @param message 要计算 hash 的字符串
 * @returns 十六进制格式的 hash 字符串
 */
export async function sha256(message: string): Promise<string> {
  const msgBuffer = new TextEncoder().encode(message)
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
}
